import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FolderKanban, Package, ChevronRight, Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileRDProjectDetailPage() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/rd/projects/${projectId}`).then(r => setProject(r.data)).catch(() => {}),
      axios.get(`${API}/rd/projects/${projectId}/items`).then(r => setItems(r.data || [])).catch(() => {}),
    ]).finally(() => setLoading(false));
  }, [projectId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!project) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>Project not found</p></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/rd/projects')}><ArrowLeft size={18} /> Projects</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: '#5856d6', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: 'white' }}><FolderKanban size={24} /></div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e' }}>{project.name || project.project_name}</div>
        <span className={`mobile-status-badge ${project.status === 'active' ? 'in_production' : 'scheduled'}`} style={{ marginTop: 8 }}>{project.status || 'active'}</span>
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Details</div>
        {project.customer_name && <div className="mobile-detail-row"><span className="mobile-detail-label">Customer</span><span className="mobile-detail-value">{project.customer_name}</span></div>}
        {project.description && <div className="mobile-detail-row"><span className="mobile-detail-label">Description</span><span className="mobile-detail-value" style={{ maxWidth: '60%', textAlign: 'right' }}>{project.description}</span></div>}
        <div className="mobile-detail-row"><span className="mobile-detail-label">Items</span><span className="mobile-detail-value">{project.items_count || items.length}</span></div>
        {project.broker_name && <div className="mobile-detail-row"><span className="mobile-detail-label">Broker</span><span className="mobile-detail-value">{project.broker_name}</span></div>}
        {project.broker_rate && <div className="mobile-detail-row"><span className="mobile-detail-label">Broker Rate</span><span className="mobile-detail-value">{project.broker_rate}%</span></div>}
      </div>
      {items.length > 0 && (
        <>
          <div className="mobile-section-header"><span className="mobile-section-title">Items</span><span style={{ fontSize: 13, color: '#8e8e93' }}>{items.length}</span></div>
          <div className="mobile-menu-list">
            {items.map(item => (
              <button key={item.item_id || item.id} className="mobile-menu-item" onClick={() => navigate(`/mobile/rd/items/${item.item_id || item.id}`)}>
                <div className="mobile-menu-item-icon" style={{ background: '#5856d6' }}><Package size={16} /></div>
                <div className="mobile-menu-item-content">
                  <div className="mobile-menu-item-title">{item.name || item.item_name}</div>
                  <div className="mobile-menu-item-subtitle">{item.status || 'draft'}{item.selling_price ? ` · $${item.selling_price.toFixed(2)}` : ''}{item.margin_percent ? ` · ${item.margin_percent.toFixed(1)}% margin` : ''}</div>
                </div>
                <ChevronRight size={16} className="mobile-menu-item-chevron" />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
